const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 13/12/16.
 */

const React = require('react');

const {formatText} = require('core/i18n').i18n;
const OKSelect = require('components/commons/OKSelect/OKSelect');
const mockHelper = require('../../../utilities/mockDataHelper');

class Activity extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="ok-slider__text">{formatText('contractsView-checkingAccountWorkTypeTitle')}</div>
                <OKSelect
                    placeholder={formatText('contractsView-checkingAccountWorkTypePlaceholder')}
                    searchable={true}
                    options={mockHelper.mockActivity(this.props.workType)}
                    onChange={this.props.handleOnChange}
                    value={this.props.selectedActivity}
                />
            </div>
        );
    }
}

Activity.propTypes = {
    handleOnChange: PropTypes.func,
    workType: PropTypes.number,
    selectedActivity: PropTypes.number
};

module.exports = Activity;